import type { TFunction } from 'i18next'

import { defaultInvoiceTextTranslationKeys } from '@features/invoices/constants/defaultInvoiceTextTranslationKeys'

import type { InvoiceSettingsForm } from '../types/invoiceSettingsForm'

export const prepareInvoiceSettingsPayloadTexts = (
  formData: Pick<InvoiceSettingsForm, 'footerNote' | 'language' | 'message'>,
  t: TFunction,
): { footerNote: string; message: string } => {
  const invoiceLocale = formData.language
  const trimmedFooterNote = formData.footerNote.trim()
  const trimmedMessage = formData.message.trim()
  const isDefaultFooterNote =
    trimmedFooterNote === t(defaultInvoiceTextTranslationKeys.footerNote, { lng: invoiceLocale })
  const isDefaultMessage = trimmedMessage === t(defaultInvoiceTextTranslationKeys.message, { lng: invoiceLocale })

  return {
    footerNote: isDefaultFooterNote ? '' : trimmedFooterNote,
    message: isDefaultMessage ? '' : trimmedMessage,
  }
}
